var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 4H5.5C4.70435 4 3.94129 4.31607 3.37868 4.87868C2.81607 5.44129 2.5 6.20435 2.5 7V17C2.5 17.7956 2.81607 18.5587 3.37868 19.1213C3.94129 19.6839 4.70435 20 5.5 20H19.5C20.2956 20 21.0587 19.6839 21.6213 19.1213C22.1839 18.5587 22.5 17.7956 22.5 17V7C22.5 6.20435 22.1839 5.44129 21.6213 4.87868C21.0587 4.31607 20.2956 4 19.5 4V4ZM5.5 18C5.23478 18 4.98043 17.8946 4.79289 17.7071C4.60536 17.5196 4.5 17.2652 4.5 17V14.58L7.8 11.29C7.98693 11.1068 8.23825 11.0041 8.5 11.0041C8.76175 11.0041 9.01307 11.1068 9.2 11.29L15.91 18H5.5ZM20.5 17C20.5 17.2652 20.3946 17.5196 20.2071 17.7071C20.0196 17.8946 19.7652 18 19.5 18H18.73L14.92 14.17L15.8 13.29C15.9869 13.1068 16.2382 13.0041 16.5 13.0041C16.7618 13.0041 17.0131 13.1068 17.2 13.29L20.5 16.58V17ZM20.5 13.76L18.62 11.89C18.0501 11.3424 17.2904 11.0366 16.5 11.0366C15.7096 11.0366 14.9499 11.3424 14.38 11.89L13.5 12.77L10.62 9.89C10.0501 9.34243 9.29036 9.03663 8.5 9.03663C7.70964 9.03663 6.94994 9.34243 6.38 9.89L4.5 11.76V7C4.5 6.73478 4.60536 6.48043 4.79289 6.29289C4.98043 6.10536 5.23478 6 5.5 6H19.5C19.7652 6 20.0196 6.10536 20.2071 6.29289C20.3946 6.48043 20.5 6.73478 20.5 7V13.76Z",
    fill: "#8F99D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRis);
export default __webpack_public_path__ + "static/media/icon_ris.e692eaf2.svg";
export { ForwardRef as ReactComponent };